import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import HomeSub from '@/views/home/index'
import TicketPurchase from '@/views/home/TicketOrder'
import Reservation from '@/views/Reservation/index'
import Introduction from '@/views/Introduction/index'
import Events from '@/views/Events/index'
import Res1 from '@/views/Reservation/Res1'
import Res2 from '@/views/Reservation/Res2'
import Res3 from '@/views/Reservation/Res3'
import Intro from '@/views/Introduction/Intro'
import AddAdult from '@/views/Reservation/AddAdult'
import store from '@/store'
import Res4 from '@/views/Reservation/Res4'
import Res5 from '@/views/Reservation/Res5'
import Fam from '@/views/Me/Fam'
import Me from '@/views/Me/index'
import Main from '@/views/Me/Main'
import Res from '@/views/Me/Res'
import Footprint from '@/views/Me/Footprint'
import List from '@/views/Events/List'
import AddAdultProcess from '@/views/Reservation/AddAdultProcess'
import ResDetail from '@/views/Me/ResDetail'
import ResCancelProcess from '@/views/Me/ResCancelProcess'
import ResReschedule from '@/views/Me/ResReschedule'
import ResRescheduleProcess from '@/views/Me/ResRescheduleProcess'
import TicketOrder from '@/views/home/TicketOrder'
import Warning from '@/views/home/Warning'
import FootprintIndex from '@/views/Footprint/index'
import FootprintWelcome from '@/views/Footprint/Welcome'
import FootprintSticker from '@/views/Footprint/Sticker'
import SpaceIndex from '@/views/space/index'
import SpaceSticker from '@/views/space/Sticker'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },

  {
    path: '/home',
    name: 'HomeSub',
    component: HomeSub,
    children: [
      {
        path: '/home/ticketOrder/:id',
        name: 'TicketOrder',
        component: TicketOrder,
        props: true,
      },
      {
        path: '/home/warning',
        name: 'Warning',
        component: Warning,
      },
    ],
  },

  // {
  //   path: '/futureshop',
  //   name: 'FutureShop',
  //   component: FutureShop,
  // },
  // {
  //   path: '/reservation/res1',
  //   name: 'Res1',
  //   component: Res1,
  // },
  {
    path: '/reservation',
    name: 'Reservation',
    component: Reservation,
    children: [
      {
        path: '/reservation/res1',
        name: 'Res1',
        component: Res1,
      },
      {
        path: '/reservation/res2',
        name: 'Res2',
        component: Res2,
      },
      {
        path: '/reservation/res3',
        name: 'Res3',
        component: Res3,
      },
      {
        path: '/reservation/res4',
        name: 'Res4',
        component: Res4,
      },
      {
        path: '/reservation/addAdult',
        name: 'AddAdult',
        component: AddAdult,
      },
      {
        path: '/reservation/addAdult/process',
        name: 'AddAdultProcess',
        component: AddAdultProcess,
      },
      {
        path: '/reservation/res5',
        name: 'Res5',
        component: Res5,
      },
    ],
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: Introduction,
    children: [
      {
        path: '/introduction/intro',
        name: 'Intro',
        component: Intro,
      },
      {
        path: '/introduction/intro/:id',
        name: 'IntroActive',
        component: Intro,
        //props: true,
        props: (route) => {
          let id = parseInt(route.params.id)
          console.log('!!!!', id)
          return { id }
        },
      },
    ],
  },
  {
    path: '/footprint',
    name: 'Footprint',
    component: FootprintIndex,
    children: [
      {
        path: '/footprint/welcome',
        name: 'FootprintWelcome',
        component: FootprintWelcome,
      },
      {
        path: '/footprint/sticker',
        name: 'FootprintSticker',
        component: FootprintSticker,
      },
    ],
  },
  {
    path: '/space',
    name: 'Space',
    component: SpaceIndex,
    children: [
      {
        path: '/space/Sticker',
        name: 'SpaceSticker',
        component: SpaceSticker,
      },
    ],
  },
  {
    path: '/events',
    name: 'Events',
    component: Events,
    children: [
      {
        path: '/events/list',
        name: 'List',
        component: List,
      },
      {
        path: '/events/list/:id',
        name: 'ListActive',
        component: List,
        //props: true,
        props: (route) => {
          let id = parseInt(route.params.id)
          console.log('!!!!', id)
          return { id }
        },
      },
    ],
  },
  {
    path: '/me',
    name: 'Me',
    component: Me,
    children: [
      {
        path: '/me/main',
        name: 'Main',
        component: Main,
      },
      {
        path: '/me/fam',
        name: 'Fam',
        component: Fam,
      },
      {
        path: '/me/res',
        name: 'Res',
        component: Res,
      },
      {
        path: '/me/footprint',
        name: 'Footprint',
        component: Footprint,
      },
      {
        path: '/me/res/:id',
        name: 'ResDetail',
        component: ResDetail,
        //props: true,
        props: (route) => {
          let id = parseInt(route.params.id)
          console.log('!!!!', id)
          return { id }
        },
      },
      {
        path: '/me/resCancel',
        name: 'ResCancel',
        component: ResCancelProcess,
      },
      {
        path: '/me/resReschedule',
        name: 'ResReschedule',
        component: ResReschedule,
      },
      {
        path: '/me/resRescheduleProcess',
        name: 'ResRescheduleProcess',
        component: ResRescheduleProcess,
      },

      {
        path: '/me/addAdult',
        name: 'AddAdult',
        component: AddAdult,
      },
      {
        path: '/me/addAdult/process',
        name: 'AddAdultProcess',
        component: AddAdultProcess,
      },
    ],
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

const REFETCH_RERUIRED_LIST = ['/']

router.beforeEach((to, from, next) => {
  console.log(to, from, next)
  if (to.name !== 'Home' && !store.state.app.user) {
    return next({ name: 'Home' })
  }

  store.commit('app/setRouterLast', from.path)
  if (from.path !== '/' && REFETCH_RERUIRED_LIST.includes(to.path)) {
    store.commit('app/setPending', true)
    store.dispatch('app/GetUser', store.state.app.user.id).then((res) => {
      store.commit('app/setPending', false)
      next()
    })
  } else next()
})

export default router
